module.exports = __webpack_public_path__ + "assets/img/assistant-help.029db0e2.png";